const workerListGridConfig = {
    columns: [
        {
            id: 1,
            width: 205,
            selector: 'egn',
            name: 'ЕГН',
            sequenceNumber: 4,
            type: 'string'
        },
        {
            id: 2,
            width: 265,
            selector: 'firstName',
            name: 'Име',
            sequenceNumber: 1,
            type: 'string'
        },
        {
            id: 3,
            width: 265,
            selector: 'middleName',
            name: 'Презиме',
            sequenceNumber: 2,
            type: 'string'
        },
        {
            id: 4,
            width: 265,
            selector: 'lastName',
            name: 'Фамилия',
            sequenceNumber: 3,
            type: 'string'
        },
        {
            id: 5,
            width: 200,
            selector: 'generalStatusName',
            name: 'Статус',
            sequenceNumber: 5,
            type: 'string',
            filterComponent: 'GeneralStatusDropdown'
        },
        {
            id: 6,
            width: 160,
            selector: 'regionName',
            name: 'Център',
            sequenceNumber: 6,
            type: 'string',
            filterComponent: 'RegionDropdown'
        },
        {
            id: 7,
            width: 200,
            selector: 'companyName',
            name: 'Фирма',
            sequenceNumber: 6,
            type: 'string',
            filterComponent: 'CompanyDropdown'
        }
    ],
    props: {
        headerRowHeight: 50,
        rowHeight: 52,
        tableHeight: 520,
        filterable: true,
        selectableColumn: {
            show: true,
            icon: 'fa fa-user',
            width: 90
        }
    }
};

export default workerListGridConfig;
